const featuredItems = [
  {
    id: 'feat-1',
    name: 'Premium Sneakers Collection',
    label: 'Trending',
    labelColor: 'bg-accent-100 text-accent-700',
    image: 'https://readdy.ai/api/search-image?query=Clean%20editorial%20product%20photography%20of%20a%20single%20pair%20of%20modern%20athletic%20sneakers%20in%20warm%20cream%20and%20sandy%20beige%20tones%20placed%20on%20a%20pristine%20white%20seamless%20studio%20backdrop%2C%20soft%20diffused%20natural%20lighting%20creating%20gentle%20elegant%20shadows%20beneath%20the%20shoe%2C%20front%20three%20quarter%20angle%20showcasing%20silhouette%20and%20material%20texture%2C%20minimalist%20contemporary%20ecommerce%20aesthetic%2C%20high%20resolution%20detail%20visible%20on%20fabric%20and%20sole%2C%20no%20visible%20branding%20or%20logos&width=600&height=600&seq=feat-sneakers-v2-01&orientation=squarish',
  },
  {
    id: 'feat-2',
    name: 'Essential Hoodies & Sweaters',
    label: 'Popular',
    labelColor: 'bg-secondary-100 text-secondary-700',
    image: 'https://readdy.ai/api/search-image?query=Studio%20product%20photography%20of%20a%20single%20oversized%20hoodie%20in%20muted%20oatmeal%20beige%20tone%20folded%20elegantly%20on%20a%20pure%20white%20seamless%20background%2C%20soft%20natural%20diffused%20lighting%20with%20subtle%20shadow%20underneath%20creating%20depth%2C%20editorial%20ecommerce%20style%20with%20clean%20minimalist%20composition%2C%20visible%20knit%20texture%20and%20fabric%20weight%2C%20warm%20neutral%20aesthetic%2C%20no%20visible%20branding%20or%20text&width=600&height=600&seq=feat-hoodie-v2-02&orientation=squarish',
  },
  {
    id: 'feat-3',
    name: 'Designer Bags & Backpacks',
    label: 'New',
    labelColor: 'bg-accent-100 text-accent-700',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20studio%20product%20shot%20of%20a%20single%20structured%20canvas%20backpack%20in%20warm%20taupe%20sand%20color%20standing%20upright%20on%20a%20clean%20white%20seamless%20surface%2C%20soft%20natural%20diffused%20overhead%20lighting%20creating%20gentle%20even%20illumination%2C%20editorial%20fashion%20ecommerce%20style%20with%20front%20facing%20composition%2C%20premium%20material%20texture%20and%20stitching%20detail%20visible%2C%20elegant%20contemporary%20aesthetic%2C%20no%20visible%20branding&width=600&height=600&seq=feat-bag-v2-03&orientation=squarish',
  },
];

export default function FeaturedProducts() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Featured
            <br />
            This Week
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredItems.map((item) => (
            <div
              key={item.id}
              data-product-shop
              className="group bg-white border border-background-200 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-300"
            >
              <div className="relative w-full aspect-square bg-white overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${item.labelColor}`}>
                  {item.label}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">
                  {item.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}